
export default {
	props: {
		item: {
			type: Object,
			default: () => {}
		}
	},
	methods: {
		// 跳转砍价详情
		gotoBargainDetails(val) {
			this.$router.push(`/account/bargainMe/details?bargainOrderNo=${val.bargainOrderNo}&goodsNo=${val.goodsNo}`)
			// 同一页
			if (this.$route.path === '/account/bargainMe/details') {
				this.$router.go(0)
			}
		},
		// 砍价卡片点击立即购买
		jumpOrderDetail(val) {
			// 埋点
			this.$store.dispatch('tracking/PointList', { event: 'BARGAIN_CARD_BUY' })
			this.$api.getCheckGoodsStatus({ goodsNo: val.goodsNo }).then(res => {
				if (res.success) {
					// 已有订单
					if (res.data !== null) {
						this.$router.push(`/account/buyerDetails?orderNo=${res.data}`)
					} else {
						// 没有生成订单则跳转到砍价的订单确认页
						this.$router.push(`/confirmOrder/onlinePay?goodsNo=${val.goodsNo}`)
						// 为啥要用 sessionStorage 来传数据！！！
						const order = {
							...val,
							bargainOrderNo: val.bargainOrderNo,
							bargainPrice: val.remainWaitPayFee
						}
						sessionStorage.setItem('orderDtl', JSON.stringify(order))
					}
				} else {
					// 提示商品状态
					this.$message.error(res.info)
				}
			})
		}
	}
}
